import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Carousel } from '../Carousel';
import styles from './HomeBanners.module.css';
export default function HomeBanners({ title, items, filteredBanners, autoPlay = true, interval = 5000, 'data-testid': dataTestId, }) {
    const filteredItems = React.useMemo(() => {
        if (!filteredBanners || filteredBanners.length === 0) {
            return items;
        }
        return items.filter(item => filteredBanners.includes(item.id));
    }, [items, filteredBanners]);
    const safeFilteredItems = React.useMemo(() => {
        return filteredBanners && filteredBanners.length > 0
            ? filteredItems.map(item => ({
                ...item,
                onClick: undefined,
            }))
            : filteredItems;
    }, [filteredItems, filteredBanners]);
    if (!safeFilteredItems?.length) {
        return null;
    }
    return (_jsxs("div", { className: styles.homeBannersSection, "data-testid": dataTestId, children: [_jsx("h2", { className: styles.homeBannersTitle, children: title }), _jsx(Carousel, { items: safeFilteredItems, autoPlay: autoPlay, interval: interval, "data-testid": 'home-carousel' })] }));
}
